"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function prepareAddressList(concatAddresses) {
  if (!concatAddresses) return "";
  var addresses = concatAddresses.split(/[,;]+/); //split by semicolon or comma

  addresses = addresses.map(function (address) {
    return address.trim();
  }); //remove any leading or trailing whitespace
  addresses = addresses.filter(function (address) {
    return address.length > 0;
  }); //remove any empty addresses

  if (addresses.length === 0)
    //no addresses
    return "";
  addresses.join(","); //now join them all with a comma
  return addresses;
}
var Email = exports.Email = {
  validateEmail: function validateEmail(email) {
    var regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return regex.test(String(email).toLowerCase());
  },
  //Sends email using the default mail client. concatAddresses is a string of email addresses separated by commas or semicolons
  sendEmail: function sendEmail(concatAddresses) {
    window.location = "mailto:" + prepareAddressList(concatAddresses);
  },
  //Sends BCC email using the default mail client. concatAddresses is a string of email addresses separated by commas or semicolons
  bccSendEmail: function bccSendEmail(concatAddresses) {
    window.location = "mailto:?bcc=" + prepareAddressList(concatAddresses);
  },
  sendEmailToMemberships: function sendEmailToMemberships(membershipsEmails) {
    var addresses = membershipsEmails.map(function (membershipsEmail) {
      return prepareAddressList(membershipsEmail);
    }); //get an array of all prepared addresses

    addresses.join(","); //now join them all with a comma

    window.location = "mailto:" + addresses;
  },
  // Given an array of email strings (which may contain multiple email addresses seperated by comma/semicolon), 
  // build a string of email addresses seperated by semicolons and copy to the clipboard. Remove duplicates.
  // Return number of email addresses copied
  copyEmailAddressesToClipboard: function copyEmailAddressesToClipboard(emailFieldList) {
    var emailList = [];

    // From the list of membership Emails, extract each email and push to the list
    var _iterator = _createForOfIteratorHelper(emailFieldList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var emailField = _step.value;
        if (emailField && emailField.length > 0) {
          var emailAddresses = emailField.split(/[,;]+/); //split by semicolon or comma
          emailAddresses = emailAddresses.map(function (address) {
            return address.trim();
          }); //remove any leading or trailing whitespace
          emailAddresses = emailAddresses.filter(function (address) {
            return address.length > 0;
          }); //remove any empty addresses
          emailList.push.apply(emailList, _toConsumableArray(emailAddresses));
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (emailList.length === 0) return 0;

    // Remove duplicates
    emailList.sort();
    for (var i = 1; i < emailList.length; i++) {
      if (emailList[i] === emailList[i - 1]) {
        emailList.splice(i, 1);
        i--;
      }
    }
    var count = emailList.length;
    var emailConcat = emailList.join("; ");

    // Copy to clipboard
    navigator.clipboard.writeText(emailConcat).then(function () {
      console.log(count + " email addresses copied to clipboard");
    });
    return count;
  }
};